import { PageTitle } from "Components/Titles";
import { Container } from "semantic-ui-react";
import { UpdateCompanyUnits } from "Features/CompanyUnit";
import { useTranslation } from "react-i18next";

function EditCompanyUnits () {

    const { t } = useTranslation();

    return (
        <Container className="page">
            <PageTitle title={t("pages.editCompanyUnits")} />
            <UpdateCompanyUnits />
        </Container>
    );
}

export default EditCompanyUnits;